<template>
    <div id="support" class="row">

        <div class="col-12 col-lg-4">
        
            <h4>Escolha o tipo de ajuda</h4>

            <!-- <a v-on:click="supportAction = 'technical'">
                <h5>SUPORTE TÉCNICO</h5>
                <p>Abra um chamado com a nossa equipe</p>
            </a> -->

            <!-- <a v-on:click="supportAction = 'pricing'">
                <h5>CONTRATAÇÃO E LICENÇA</h5>
                <p>Ajuda no preço ou na sua conta</p>
            </a> -->

            <!-- <a v-on:click="supportAction = 'documentation'">
                <h5>DOCUMENTAÇÃO</h5>
                <p>Guias para utilização dos produtos</p>
            </a> -->

            <!-- <a v-on:click="supportAction = 'contact'">
                <h5>FALE CONOSCO</h5>
                <p>Converse diretamente com a equipe da TARS</p>
            </a> -->
        </div>

        <div class="col-12 col-lg-8" v-if="supportAction == 'technical'">
        
            <h4>Entrar em contato com o suporte</h4>

            <p>Precisa de ajuda? Nos envie um pedido!</p>

            <span>
                Se você acredita que o problema é um bug de sistema, nos dê mais
                informações aqui e nós trataremos o caso com o time de desenvolvimento.                  
            </span>
            
            <div>
                <span>Qual produto que você precisa de ajuda?</span>
            </div>

            <div>
                <span>Qual módulo está sendo afetado?</span>
            </div>

            <div>
                <span>Qual o seu e-mail?</span>
            </div>

            <div>
                <span>Nos diga o resumo do seu prolema</span>
            </div>

            <div>
                <span>Qual o impacto desse problema para o seu negócio?*</span>
            </div>

            <div>
                <span>Por favor, nos dê mais detalhes do problema</span>
            </div>

            <!-- <div>
                <span>
                Permito que a equipe de Suporte da TARS acesse dados da minha conta
                do TARS One para ajudar a solucionar a minha solicitação.
                </span>
            </div> -->

            <button>Enviar solicitação de auxílio</button>

        </div>

        <div class="col-12 col-lg-8" v-if="supportAction == 'pricing'">
        
            <h5> Suporte e treinamento </h5>

            <p>Quais tipos de suporte a TARS oferece?</p>

            <p>Quais tipos de treinamento a TARS oferece?</p>

            <h5> Gestão da conta </h5>

            <p>Qual o limite de contas para o TARS One?</p>

            <p>Como eu gerencio os e-mails da minha conta?</p>

            <p>Como eu atualizo as informações de pagamento da minha conta?</p>

            <p>Como eu altero minha senha?</p>

            <p>Como eu acesso meus recibos de pagamento?</p>

            <p>Como eu excluo a minha conta?</p>

            <h5> Termos </h5>

            <h5> Privacidade & LGPD </h5>

            <h5> Customização </h5>

            <h5> Código fonte </h5>

        </div>

        <div class="col-12 col-lg-8" v-if="supportAction == 'documentation'">
        
        

        </div>
        
        <div class="col-12 col-lg-8" v-if="supportAction == 'contact'">
        
        

        </div>

    </div>
</template>

<script>
export default {
    name: 'support',
    data: function () {
        return {
            supportAction: ''
        }
    }
}
</script>

<style lang="scss">

#support {
    max-width: 1200px;
    margin: 20px;

    h4 {
        font-size: 16px;
        margin-bottom: 20px;
    }

    h5 {
        font-size: 14px;
        margin: 15px 0 0 0;            
    }

    p {
        font-size: 13px;
        margin: 0;
    }

    a {
        cursor: pointer;
    }

    a:hover > h5 {
        color: #25b686;            
    }
} 

</style>

